export const isInnerUser = (ac_email: string): boolean => {
  if (!ac_email) return false;

  return ac_email.endsWith('@howtelevision.jp');
};
